export function fireEvent(eventKey: string){
  const event = document.createEvent('Event');
  event.initEvent(eventKey, true, true);
  window.dispatchEvent(event);
}
